import React from 'react';
import Spin from './Spin';

const LoaderFallback = () => {
  return <Spin />;
};

export default LoaderFallback;
